<div class="stick-top">
  <mat-toolbar><mat-icon>terrain</mat-icon> Regions</mat-toolbar>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="auth.hasRole('SITE_ACCESS_ADMIN')">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId"></micro-company-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Region Name
          <input [(ngModel)]="filter.name">
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.hasRole('SITE_ACCESS_ADMIN')"><micro-company-lookup [companyId]="element.companyId" [link]="false"></micro-company-lookup></td>
      <td><a routerLink="/sa/regions/{{element.id}}">{{element.name}}</a></td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
